import * as yup from 'yup';

import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
};

export class MetatagType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Metatag';

  friendlyName = 'Metatag';

  contexts = [TypeContextEnum.Block];

  superUserOnly = false;
  properties = properties;

  get example() {
    return {
      _id: '2T7eVcALclaDA326A3RkwR',
    };
  }

  get default(): any {
    return null;
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }
}

const definition = new MetatagType();

Types.addBaseType(definition);
export { definition as MetatagDefinition };
